const initialState = {
  allSsaStudents: [],
  selectedSsaStudent: '',
  nonCompliantOnly: false,
  selectedStudentsList: [],
  selectedSsaStudentDetails: {},
  selectedMultipleStudents: false,
  selectedStudentHeadingDetails: {},
};

export default initialState;
